import React, {Component} from 'react';
import './pScene7.css';
import {FormattedMessage} from "react-intl";
import BgGrid from "../../BgGrid";

class PScene7 extends Component<> {
    componentDidMount() {
    }

    render() {
        return (
        <section className={"p-container"}>
            <div id={'pscene7'} className='content accessibility-img'>
                <BgGrid className={'p-bg-grid'} id='p_s7bg'
                        hLines={5} vLines={4} stroke={'white'} />
                <h3 className={"p-text-container-scene-7 s7-txt"}>
                    <span className={'p-text'}>
                        <FormattedMessage id={"home_technology_creativity_txt"}/>
                        <span> </span>
                        <FormattedMessage id={"home_technology_creativity_txt_3"}/>
                    </span>
                </h3>
            </div>
        </section>)
    }
}

export default PScene7;
